// extracted by mini-css-extract-plugin
module.exports = {"base":"McsTagWithLabel_base__2IyYZ","tag":"McsTagWithLabel_tag__15NMs","text":"McsTagWithLabel_text__JL7-f"};